export { default as VegaPlot, DATASET_NAME } from './VegaPlot';
export { VEGA_THEMES } from './utils';
